import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '@/features/auth/use-auth';
import { useBrand } from '@/features/branding/brand-provider';

// Mirrors the Next `[brand]/route.ts`: a bare "/:brand" sends admins to the
// admin area and everyone else to the trainee login.
export function BrandIndex() {
  const { slug } = useBrand();
  const { user, loading } = useCurrentUser();

  if (loading) {
    return (
      <div className="flex h-dvh items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }

  return <Navigate to={user ? `/${slug}/admin` : `/${slug}/login`} replace />;
}
